export enum AccessControlServiceEntity {
  CCure = 'CCURE_2_8__2_9',
  Braxos = 'BRAXOS_1_0',
  Genea = 'GENEA_2_0',
  Openpath = 'OPENPATH_1_0',
  Amag = 'AMAG_9_0',
  Brivo = 'BRIVO_1_0',
  Datawatch = 'DATAWATCH_1_0',
  Maxxess = 'MAXXESS_6_0',
  Genetec = 'GENETEC_5_9',
  Gallagher = 'GALLAGHER_8_9',
  Dsx = 'DSX_6_0',
  SaltoSvn = 'SALTO_SVN_1_35',
  Sipass = 'SIPASS_1_0',
  Kastle = 'KASTLE_1_0',
}
